import { ShimmerLayout, ShimmerRow } from "components/ShimmerRow/shimmer";
import React from "react";


export const SelectedAddressLoader = () => (
  <div className="prl15 mtb15 full-wrap existing-customer-shipping bottom-fix-space default-address-loader-container">
    <header className="header-action">
      <ShimmerLayout className="layout horizontal justified center wrap ">
        <ShimmerRow margin="10px" width="60%" height="40px" />
        <ShimmerRow margin="10px" width="20%" height="40px" />
      </ShimmerLayout>

    </header>

    <ShimmerLayout className="layout horizontal justified center wrap ">
      <ShimmerRow margin="10px" width="100%" height="10px" />
      <ShimmerRow margin="10px" width="80%" height="10px" />
      <ShimmerRow margin="10px" width="80%" height="10px" />
      <ShimmerRow margin="10px" width="60%" height="10px" />
    </ShimmerLayout>
  </div>
);
